<template>
  <MainStructure>
    <div class="d-flex flex-column align-items-center h-100">
      <FiltersStudentPanelVue ref="filterRef"
                              @dataFetched="atualizarDados"/>

      <div id="panel-container" class="container d-flex flex-column align-items-center pb-4">
        <div id="print-buttons" class="w-100 d-flex justify-content-end">
          <div v-if="hasDemoData" class="demo-data-warning"><i class="bi bi-exclamation-circle-fill"></i> Os dados abaixo incluem dados de demonstração.</div>

          <button @click="downloadSpreadsheet"
                  :disabled="!panelData.students || panelData.students?.length <= 0 || isDownloadingOrPrinting"
                  :title="panelData.students?.length <= 0 ? 'Necessário haver pelo menos um estudante para poder baixar o acompanhamento': ''"
                  :class="{'pointer-events-auto-disabled': panelData.students?.length <= 0}"
                  class="btn btn-link text-decoration-none">
            <span class="spinner-border spinner-border-sm" aria-hidden="true" v-if="isDownloadingOrPrinting"/>
            <i v-else class="bi bi-filetype-xls"></i> Baixar
          </button>

          <button @click="printPanel"
                  :disabled="!panelData.students || panelData.students?.length <= 0 || isDownloadingOrPrinting"
                  :title="panelData.students?.length <= 0 ? 'Necessário haver pelo menos um estudante para poder imprimir o painel': ''"
                  :class="{'pointer-events-auto-disabled': panelData.students?.length <= 0}"
                  class="btn btn-link text-decoration-none ml-2">
            <i class="bi bi-filetype-pdf"></i> Imprimir
          </button>
        </div>

        <div class="row w-100 pb-2 mx-2">
          <div class="col-3 p-0 d-flex flex-column pe-2">
            <div id="students" class="shadow card h-100 w-100 mb-2">
              <div class="card-body">
                <h5 class="card-title fw-bold align-self-start">Estudantes</h5>
                <div class="d-flex flex-column justify-content-center align-items-center">
                  <div v-if="isLoading">
                    <div class="skeleton skeleton-text"/>
                  </div>

                  <p v-else class="card-text font-size-info-card fw-bold text-blue">{{ panelData.totalStudents }}</p>
                </div>
              </div>
            </div>

            <div id="average-exercises-per-student" class="shadow card h-100 w-100 mb-2">
              <div class="card-body">
                <h5 class="card-title fw-bold">Práticas médias por estudante</h5>
                <div class="d-flex flex-column justify-content-center align-items-center">
                  <div v-if="isLoading">
                    <div class="skeleton skeleton-text"/>
                  </div>

                  <p v-else class="card-text font-size-info-card fw-bold">{{ panelData.averageExercisesPerStudent }}</p>
                </div>
              </div>
            </div>

            <div id="average-time-per-exercise" class="shadow card h-100 w-100">
              <div class="card-body">
                <h5 class="card-title fw-bold">Tempo médio por prática (min)</h5>
                <div class="d-flex flex-column justify-content-center align-items-center">
                  <div v-if="isLoading">
                    <div class="skeleton skeleton-text"/>
                  </div>

                  <p v-else class="card-text font-size-info-card fw-bold">{{ panelData.averageTimePerExercise }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-9 p-0 d-flex">
            <div id="exercises-table" class="shadow card h-100 w-50 me-2">
              <div class="card-body">
                <h5 class="card-title fw-bold">Práticas</h5>

                <div v-if="isLoading">
                  <div class="skeleton skeleton-rect"/>
                </div>

                <div v-else class="table-responsive height-table">
                  <table class="table table-sm" v-if="Object.keys(panelData.students).length > 0">
                    <thead>
                    <tr>
                      <th scope="col">Estudante</th>
                      <th v-for="(exercise, index) in exercisesOrder" :key="exercise.title" :title="exercise.title" scope="col">
                        <span>P{{ index + 1 }}</span>
                      </th>
                    </tr>
                    </thead>
                    <tbody class="exercises-tbody">
                    <tr v-for="(student, username) in panelData.students" :key="username">
                      <td class="student-name ellipsis" :title="student.name">{{ student.name }}</td>
                      <td v-for="exercise in exercisesOrder" :key="exercise.title" class="text-center">
                        {{ student.exercises.find(e => e.title === exercise.title)?.completed ? 'X' : '' }}
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <table v-else class="table table-sm">
                    <thead>
                    <tr>
                      <th class="text-center" scope="col">Sem dados</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td class="text-center">Nenhum dado encontrado.</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div id="performance-distribution" class="shadow card h-100 w-50">
              <div class="card-body">
                <h5 class="card-title fw-bold">Distribuição desempenho estudantes</h5>
                <div v-if="isLoading">
                  <div class="skeleton skeleton-rect"/>
                </div>

                <StudentPerformanceChart v-else ref="performanceDistributionRef"/>
              </div>
            </div>
          </div>
        </div>

        <div class="row w-100">
          <div id="error-distribution" class="col-3 p-0 pe-2">
            <div class="shadow card h-100 w-100 me-2">
              <div class="card-body width-chart-error d-flex flex-column align-items-center">
                <h5 class="card-title fw-bold align-self-start">Distribuição de erros</h5>

                <div v-if="isLoading">
                  <div class="skeleton skeleton-avatar"/>
                </div>

                <ErrorDistributionChart v-else ref="errorDistributionRef"/>
              </div>
            </div>
          </div>

          <div class="col-9 p-0">
            <div v-if="isLoading">
              <div class="skeleton skeleton-rect"/>
            </div>

            <div id="exercises-cards" v-else class="exercises-container w-100 h-100 height-limit-cards">
              <div class="p-4 overflow-y-auto overflow-x-hidden h-100">
                <span class="section-title">ACOMPANHAMENTO POR PRÁTICA</span>

                <div v-for="lab in exercisesByLaboratory" :key="lab.laboratory_id" class="lab-group mb-4">
                  <div class="d-flex align-items-center gap-2 mb-3">
                    <i :class="lab.laboratory_icon || 'pi pi-flask'" class="lab-icon"></i>
                    <span class="fw-bold text-secondary">{{ lab.laboratory_title }}</span>
                    <span class="lab-badge">{{ lab.exercises.length }} Prática{{ lab.exercises.length > 1 ? 's' : '' }}</span>
                  </div>

                  <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3">
                    <div class="col" v-for="exercise in lab.exercises" :key="exercise.order">
                      <div class="practice-card position-relative">
                        <div class="d-flex justify-content-between align-items-start mb-2">
                          <span class="practice-title">{{ exercise.title }}</span>
                          <i v-if="authStore.getLoggedInUsernameAndName()?.profile === 'Admin'"
                             class="pi pi-pencil practice-edit-icon"
                             @click="openThresholdModal(exercise)"
                             title="Editar limiar"></i>
                        </div>

                        <div class="d-flex justify-content-between align-items-center mb-1">
                          <span class="metric-label">Conclusão</span>
                          <span class="metric-value">{{ exercise.completed }}</span>
                        </div>
                        <div class="progress-bar-container mb-2">
                          <div class="progress-bar-fill" :style="{ width: parseCompletion(exercise.completed) + '%' }"></div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center mb-1">
                          <span class="metric-label">Tempo Médio</span>
                          <span class="metric-value"
                                :class="{'highlight': exercise.highlight}"
                                :title="exercise.highlight ? 'Ultrapassou o limiar' : ''"
                                v-tooltip.top="{
                                  value: exercise.threshold_seconds != null ? `Limiar atual: ${exercise.threshold_seconds}s` : undefined,
                                  pt: { root: { class: 'threshold-tooltip' } }
                                }">{{ exercise.averageTime }}s</span>
                        </div>

                        <div class="d-flex justify-content-between align-items-center">
                          <span class="metric-label">Acurácia</span>
                          <span class="metric-value">{{ exercise.accuracy }}%</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <EditThresholdModal v-model:visible="isModalVisible" 
                        :exercise="selectedExercise" 
                        @saved="onThresholdSaved" />
  </MainStructure>
</template>

<script setup>
import MainStructure from '@/components/layoutParts/MainStructure.vue';
import EditThresholdModal from '@/components/Modals/EditThresholdModal.vue';

import ErrorDistributionChart from '@/views/Teacher/charts/ErrorDistributionChart.vue';
import StudentPerformanceChart from '@/views/Teacher/charts/StudentPerformanceChart.vue';
import FiltersStudentPanelVue from './FiltersStudentPanel.vue';
import {ref, watch, computed, nextTick} from "vue";
import PanelService from "@/services/panel.service";
import DownloadUtils from "@/utils/download.utils";
import ErrorUtils from "@/utils/error.utils";
import {useAuthStore} from '@/stores/auth';
import {useTour} from '@/composables/useTour';

const errorDistributionRef = ref();
const performanceDistributionRef = ref();
const filterRef = ref();

const panelData = ref({});
const exercisesOrder = ref([]);

const authStore = useAuthStore();

const isModalVisible = ref(false);
const selectedExercise = ref(null);

const isLoading = ref(true);
const isDownloadingOrPrinting = ref(false);
const hasDemoData = ref(false);

const exercisesByLaboratory = computed(() => {
  const exercises = panelData.value.exercises || [];
  const grouped = {};
  for (const ex of exercises) {
    const labId = ex.laboratory_id || 0;
    if (!grouped[labId]) {
      grouped[labId] = {
        laboratory_id: labId,
        laboratory_title: ex.laboratory_title || 'Sem laboratório',
        laboratory_icon: ex.laboratory_icon || 'pi pi-flask',
        exercises: []
      };
    }
    grouped[labId].exercises.push(ex);
  }
  return Object.values(grouped).sort((a, b) => a.laboratory_id - b.laboratory_id);
});

function downloadSpreadsheet() {
  if (filterRef.value.selectedStudents.length <= 0 || !filterRef.value.selectedPeriod) {
    filterRef.value.setErrorMessage("Necessário haver pelo menos um estudante para poder baixar o acompanhamento");
    return;
  }

  isDownloadingOrPrinting.value = true;

  PanelService.downloadSpreadsheet(filterRef.value.selectedStudents, filterRef.value.selectedPeriod)
      .then(response => {
        const fileName = response.headers['content-disposition'].split('filename=')[1];
        DownloadUtils.downloadSpreadsheet(response.data, fileName);
      })
      .catch(error => filterRef.value.setErrorMessage(ErrorUtils.toMessage(error)))
      .finally(() => isDownloadingOrPrinting.value = false);
}

function printPanel() {
  if (filterRef.value.selectedStudents.length <= 0 || !filterRef.value.selectedPeriod) {
    filterRef.value.setErrorMessage("Necessário haver pelo menos um estudante para poder imprimir o painel");
    return;
  }

  try {
    const originalContent = document.getElementById('panel-container');
    const clonedContent = originalContent.cloneNode(true);

    const printButtons = clonedContent.querySelector('#print-buttons');
    if (printButtons) {
      printButtons.remove();
    }

    const exercisesTable = clonedContent.querySelector('#exercises-table');
    exercisesTable.classList.remove('h-100', 'w-50');
    exercisesTable.classList.add('w-100');

    const heightTable = exercisesTable.querySelector('.height-table');
    if (heightTable) {
      heightTable.classList.remove('height-table');
    }

    const originalCanvases = originalContent.querySelectorAll('canvas');
    const clonedCanvases = clonedContent.querySelectorAll('canvas');

    originalCanvases.forEach((canvas, index) => {
      const img = new Image();
      img.src = canvas.toDataURL('image/png');
      img.style.maxWidth = '100%';
      img.style.height = 'auto';

      const clonedCanvas = clonedCanvases[index];
      if (clonedCanvas?.parentNode) {
        clonedCanvas.parentNode.replaceChild(img, clonedCanvas);
      }
    });

    const allShadowElements = clonedContent.querySelectorAll('*');
    allShadowElements.forEach(element => {
      element.classList.remove('shadow');
    });

    const errorDistribution = clonedContent.querySelector('#error-distribution');
    errorDistribution.classList.add('w-50', 'avoid-page-break');

    const firstDivError = errorDistribution.querySelector('div');
    if (firstDivError) {
      firstDivError.classList.add('align-items-center');
    }

    const performanceDistribution = clonedContent.querySelector('#performance-distribution');
    performanceDistribution.classList.add('w-50', 'avoid-page-break');

    const firstDivPerformance = performanceDistribution.querySelector('div');
    if (firstDivPerformance) {
      firstDivPerformance.classList.add('d-flex', 'flex-column', 'align-items-center');
    }

    const h5Elements = clonedContent.querySelectorAll('h5.card-title');
    h5Elements.forEach(h5 => h5.classList.remove('align-self-start'));

    const exercisesCards = clonedContent.querySelector('#exercises-cards');
    exercisesCards.classList.remove('height-limit-cards', 'h-100');
    exercisesCards.classList.add('overflow-visible');

    const customCards = exercisesCards.querySelectorAll('.custom-card-dash');
    customCards.forEach(card => card.classList.add('avoid-page-break'));

    const reorganizedLayout = document.createElement('div');
    reorganizedLayout.innerHTML = `
      <div style="display: flex; width: 100%; gap: 10px;">
        <div style="width: 33%;">${clonedContent.querySelector('#students')?.outerHTML}</div>
        <div style="width: 33%;">${clonedContent.querySelector('#average-exercises-per-student')?.outerHTML}</div>
        <div style="width: 33%;">${clonedContent.querySelector('#average-time-per-exercise')?.outerHTML}</div>
      </div>

      <div style="width: 100%; margin-top: 20px;">
        ${exercisesTable.outerHTML}
      </div>

      <div style="display: flex; gap: 10px; margin-top: 20px;" class="w-100">
        ${errorDistribution.outerHTML}
        ${performanceDistribution.outerHTML}
      </div>

      <div style="width: 100%; margin-top: 20px;">
        ${exercisesCards.outerHTML}
      </div>
    `;

    const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
        .map((style) => style.outerHTML)
        .join('');

    let title = 'acompanhamento_pratica_lab_turmas_'
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    title += `${day}_${month}_${year}`;

    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html lang="pt-br">
        <head>
          <title>${title}</title>
          ${styles}
          <style>
            @media print {
              body {
                margin: 0;
                padding: 0;
              }

              .skeleton {
                display: none !important;
              }

              .pointer-events-auto-disabled {
                display: none !important;
              }

              .avoid-page-break {
                page-break-inside: avoid;
                break-inside: avoid;
              }

              .w-100 {
                width: calc(100% - 2px) !important;
              }
            }
          </style>
        </head>
        <body>
          ${reorganizedLayout.outerHTML}
        </body>
      </html>
    `);

    triggerPrint(printWindow);
  } catch (e) {
    filterRef.value.setErrorMessage(ErrorUtils.toMessage(e));
  }
}

function triggerPrint(printWindow) {
  printWindow.document.close();
  printWindow.focus();

  printWindow.onload = () => {
    printWindow.print();
    printWindow.close();
  };
}

function parseCompletion(value) {
  if (typeof value === 'string') {
    if (value === 'Sim') return 100;
    if (value === 'Não') return 0;
    return parseFloat(value) || 0;
  }
  return value || 0;
}

function openThresholdModal(exercise) {
  selectedExercise.value = exercise;
  isModalVisible.value = true;
}

async function onThresholdSaved() {
  await filterRef.value.fetchPanelData(false);
}

async function atualizarDados(data) {
  panelData.value = data;
  hasDemoData.value = data.demoData;

  if (panelData.value.students) {
    const students = Object.values(panelData.value.students);
    const exercisesOrderFirstStudent = students[0];
    if (exercisesOrderFirstStudent) {
      exercisesOrder.value = exercisesOrderFirstStudent.exercises;
    }
  }
  isLoading.value = false;

  if (errorDistributionRef.value) {
    errorDistributionRef.value.updateData(panelData.value.errorDistribution);
  }

  if (performanceDistributionRef.value) {
    performanceDistributionRef.value.updateData(panelData.value.performanceDistributionPerStudent);
  }
}

watch(errorDistributionRef, (val) => {
  if (val && panelData.value.errorDistribution) {
    val.updateData(panelData.value.errorDistribution);
  }
});

watch(performanceDistributionRef, (val) => {
  if (val && panelData.value.performanceDistributionPerStudent) {
    val.updateData(panelData.value.performanceDistributionPerStudent);
  }
});

const { startTour, registerTourListener } = useTour();
const TOUR_NAME = 'studentPanel';

function getTourSteps() {
    return [
        { element: '[data-tour="filters"]', popover: { title: 'Filtros', description: 'Use os filtros para analisar grupos específicos.' } },
        { element: '#students', popover: { title: 'Estudantes', description: 'Total de alunos com atividade registrada.' } },
        { element: '#average-exercises-per-student', popover: { title: 'Práticas médias', description: 'Quantidade média de práticas concluídas por aluno.' } },
        { element: '#average-time-per-exercise', popover: { title: 'Tempo médio', description: 'Tempo médio gasto por prática (em minutos).' } },
        { element: '#error-distribution', popover: { title: 'Distribuição de erros', description: 'Distribuição de erros por aluno/prática para identificação rápida de dificuldades.' } },
        { element: '#exercises-table', popover: { title: 'Tabela de práticas', description: 'Acompanhe o progresso individual por prática.' } },
        { element: '#performance-distribution', popover: { title: 'Gráfico de desempenho', description: 'Visualize padrões e distribuição de desempenho.' } },
        { element: '#exercises-cards', popover: { title: 'Cards por prática', description: 'Analise métricas detalhadas como conclusão, tempo e acurácia.' } }
    ];
}

registerTourListener(TOUR_NAME, getTourSteps);

watch(isLoading, (newVal) => {
    if (!newVal) {
        nextTick(() => startTour(TOUR_NAME, getTourSteps()));
    }
}, { once: true });
</script>

<style scoped>
.font-size-info-card {
  font-size: 3rem;
}

.height-table {
  max-height: 450px;
}

.custom-card-dash {
  width: 140px;
  height: 175px;
  margin: 6px;
}

.height-limit-cards {
  max-height: 500px;
}

.custom-font-size {
  font-size: 0.8rem;
}

.width-chart-error {
  max-height: 90% !important;
}

.exercises-tbody tr td:nth-child(odd) {
  background-color: #ffffff;
}

.exercises-tbody tr td:nth-child(even) {
  background-color: #f2f2f2;
}

.student-name {
  max-width: 140px;
}

.highlight {
  color: red;
}

.demo-data-warning {
  background-color: #ffff8e;
  align-self: end;
  border-radius: 6px;
  padding: 3px;
  margin-bottom: 4px;
}

.edit-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
  color: #6c757d;
  font-size: 0.9rem;
  transition: color 0.2s;
}

.edit-icon:hover {
  color: #1A5FD5;
}

.position-relative {
  position: relative;
}

/* Exercises by laboratory */
.exercises-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #f3f4f6;
}

.section-title {
  display: block;
  font-size: 10px;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 24px;
}

.lab-group {
  border-left: 4px solid #3b82f6;
  padding-left: 16px;
}

.lab-icon {
  color: #3b82f6;
  font-size: 18px;
}

.lab-badge {
  background-color: #dbeafe;
  color: #2563eb;
  font-size: 10px;
  font-weight: 700;
  border-radius: 9999px;
  padding: 2px 8px;
}

.practice-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px;
  transition: box-shadow 0.2s;
}

.practice-card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.practice-title {
  font-size: 11px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.3;
}

.practice-edit-icon {
  cursor: pointer;
  color: #d1d5db;
  font-size: 14px;
  transition: color 0.2s;
}

.practice-edit-icon:hover {
  color: #3b82f6;
}

.metric-label {
  font-size: 10px;
  color: #6b7280;
}

.metric-value {
  font-size: 10px;
  font-weight: 700;
  color: #1f2937;
}

.progress-bar-container {
  height: 4px;
  background-color: #f3f4f6;
  border-radius: 9999px;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background-color: #3b82f6;
  border-radius: 9999px;
  transition: width 0.3s;
}
</style>
